var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('h4',[_vm._v(_vm._s(_vm.sectionTitle))]),_c('span',[_vm._v(" "+_vm._s((_vm.numberOfQuestions + " Pregunta(s)"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }